// Phiên bản tối thiểu của M-INVOICE Plugin hỗ trợ ký USB hóa đơn
// điều chỉnh/thay thế nhiều kèm bảng kê.
export const PLUGIN_VERSION = "1.1.1";

// Đường dẫn tải bộ cài M-INVOICE Plugin phiên bản mới nhất.
export const PLUGIN_URL =
  "https://plugin.minvoice.com.vn/MinvoicePlugin_NewApp/setup.exe";

/**
 * Chuẩn hóa dữ liệu version trả về từ hub thành mảng số để so sánh.
 * Hàm hỗ trợ cả chuỗi version và object có chứa version.
 */
const toVersionParts = (value: any): number[] => {
  const versionText =
    typeof value === "string" ? value : JSON.stringify(value ?? "");
  const matchedVersion = versionText.match(/\d+(?:\.\d+)+/);

  return matchedVersion
    ? matchedVersion[0].split(".").map((part) => Number(part))
    : [];
};

/**
 * Kiểm tra version plugin hiện tại có bằng hoặc lớn hơn version tối thiểu.
 * Các phần version được so sánh lần lượt, ví dụ 1.1.10 lớn hơn 1.1.2.
 */
export const isPluginVersionSupported = (
  currentVersion: any,
  minimumVersion = PLUGIN_VERSION,
): boolean => {
  const currentParts = toVersionParts(currentVersion);
  const minimumParts = toVersionParts(minimumVersion);

  if (!currentParts.length || !minimumParts.length) {
    return false;
  }

  const partCount = Math.max(currentParts.length, minimumParts.length);
  for (let index = 0; index < partCount; index++) {
    const currentPart = currentParts[index] || 0;
    const minimumPart = minimumParts[index] || 0;

    if (currentPart !== minimumPart) {
      return currentPart > minimumPart;
    }
  }

  return true;
};

/**
 * Xác định hóa đơn có cần kiểm tra version plugin trước khi ký USB hay không.
 * Áp dụng cho hóa đơn có liên kết bảng kê hoặc có thuộc tính hóa đơn liên quan
 * bằng 3 (thay thế nhiều) hoặc 4 (điều chỉnh nhiều).
 */
export const requiresPluginVersionCheck = (invoiceContext: any): boolean => {
  const invoices = Array.isArray(invoiceContext)
    ? invoiceContext
    : [invoiceContext];

  return invoices.some(
    (invoice) =>
      Boolean(invoice?.relatedInvoiceListId) ||
      [3, 4].includes(Number(invoice?.relatedInvoiceProperty)),
  );
};
